import { isDevToolsEnabled } from '@tallo/utility';

import { AppRouteNames } from './app-routes.enum';

interface NavigationRoute {
  appRoute: AppRouteNames;
  title: string;
  available?: () => boolean;
}

export const mainNavigationConfig: NavigationRoute[] = [
  {
    appRoute: AppRouteNames.HOME,
    title: 'Home',
  },
  {
    appRoute: AppRouteNames.INVESTOR_PORTFOLIO,
    title: 'Portfolio',
  },
  {
    appRoute: AppRouteNames.INVESTOR_CALENDAR,
    title: 'Calendar',
  },
  {
    appRoute: AppRouteNames.INVESTOR_SHOWINGS,
    title: 'Showings',
  },
  {
    appRoute: AppRouteNames.INVESTOR_INTEGRATIONS,
    title: 'Integrations',
  },
  {
    appRoute: AppRouteNames.DEV_TOOLS,
    title: 'Dev Tools',
    available: () => process.env.ENV !== 'production' && isDevToolsEnabled(),
  },
].filter((route) => {
  if (route?.available) {
    return route.available();
  }

  return true;
});
